// Tuile de la grille « Intégrations configurées » : SOURCE UNIQUE (connexions génériques, SMTP et « Claude (Matthieu) », T-278).
// Même taille, même icône dans une pastille teintée, même nom + portée, même pastille d'état à droite.
import { Star } from "lucide-react";

export const COLOR_MAP = {
  green: "text-green-400 bg-green-500/10",
  emerald: "text-emerald-400 bg-emerald-500/10",
  blue: "text-blue-400 bg-blue-500/10",
  purple: "text-purple-400 bg-purple-500/10",
  red: "text-red-400 bg-red-500/10",
  orange: "text-orange-400 bg-orange-500/10",
  pink: "text-pink-400 bg-pink-500/10",
  amber: "text-amber-400 bg-amber-500/10",
  gray: "text-[color:var(--oh-text-muted)] bg-zinc-500/10",
  violet: "text-violet-400 bg-violet-500/10",
  rose: "text-rose-400 bg-rose-500/10",
};

const PASTILLES = {
  connecte: { classe: "bg-emerald-400", libelle: "Connecté" },
  "non-connecte": { classe: "bg-amber-400", libelle: "Non connecté" },
  indisponible: { classe: "bg-zinc-500", libelle: "Indisponible" },
};

export function libelleEtat(etat) {
  return (PASTILLES[etat] || PASTILLES.connecte).libelle;
}

export default function TuileIntegration({ Icone, couleur, nom, portee, etat = "connecte", parDefaut = false, onOuvrir, ...rest }) {
  const colorClass = COLOR_MAP[couleur] || COLOR_MAP.gray;
  const pastille = PASTILLES[etat] || PASTILLES.connecte;
  return (
    <div
      role="button"
      tabIndex={0}
      className={`relative p-3 bg-zinc-900/50 rounded-lg border ${etat === "connecte" ? "border-emerald-500/30 hover:border-emerald-500/50" : "border-zinc-700/50 hover:border-zinc-600"} transition-all duration-200 cursor-pointer group`}
      onClick={onOuvrir}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onOuvrir(); } }}
      {...rest}
    >
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-105 transition-transform ${colorClass.split(" ")[1]}`}>
          <Icone className={`w-5 h-5 ${colorClass.split(" ")[0]}`} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-medium text-sm truncate" style={{ color: "var(--oh-text)" }}>{nom}</h3>
          <p className="text-xs line-clamp-1" style={{ color: "var(--oh-text-muted)" }}>{portee}</p>
        </div>
        <div className="flex-shrink-0">
          {parDefaut ? (
            <Star className="w-4 h-4 text-amber-400 fill-amber-400" />
          ) : (
            <div className={`w-2 h-2 rounded-full ${pastille.classe}`} title={pastille.libelle} data-etat={etat} />
          )}
        </div>
      </div>
    </div>
  );
}
